





import { language, reportIndexPvUvAndTimeCost } from '@tencent/ppd-base-libs';
import { wxBridge } from '@tencent/wphk-base-wx';
import { defineComponent, onMounted, ref } from '@vue/composition-api';
import { i18n } from './i18n';
import { cacheImg } from '@/utils';

export default defineComponent({
  name: 'App',
  setup() {
    const lang = ref('');
    lang.value = language.getLanguage();
    /** 缓存关键弹窗图片 */
    const cacheImgForHome = () => {
      cacheImg([
        i18n('欢迎新朋友弹窗'),
        i18n('欢迎新朋友弹窗_圣诞'),
        i18n('改版指引图片'),
      ]);
    };
    onMounted(async () => {
      // 设置HTML元素上的lang属性，便于无障碍准确识别多语言
      document.documentElement.setAttribute('lang', lang.value === 'en' ? 'en' : 'zh');
      /** 设置微信分享文案 */
      wxBridge.setShareInfo({
        title: i18n('儲印花就用WeChat Pay HK'),
        desc: i18n('可兌換超過30款熱門商戶優惠!'),
        link: 'https://prom.wechatpay.com.hk/e-stamp/index.shtml?ADTAG=fromShareInfo',
        imgUrl: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20221024111037/100x100px.png',
      });
      wxBridge.disableBounceScroll();
      cacheImgForHome();
    });
    return {
      lang,
    };
  },
  mounted() {
    reportIndexPvUvAndTimeCost();
  },
});
